import React, { useEffect } from 'react';
import { HeroSection } from './components/HeroSection';
import { OpeningHook } from './components/OpeningHook';
import { ProblemSection } from './components/ProblemSection';
import { FailedApproaches } from './components/FailedApproaches';
import { MechanismSection } from './components/MechanismSection';
import { WhatYouGet } from './components/WhatYouGet';
import { WhoIsThisFor } from './components/WhoIsThisFor';
import { HowItWorks } from './components/HowItWorks';
import { ProofSection } from './components/ProofSection';
import { FAQSection } from './components/FAQSection';
import { OfferSection } from './components/OfferSection';
import { FooterSection } from './components/Footer';
import { trackPageView } from './utils/metaPixel';
export function App() {
  useEffect(() => {
    trackPageView();
  }, []);
  return <div className="min-h-screen bg-cream selection:bg-rose-gold/30 selection:text-warm-dark overflow-x-hidden" data-id="element-0">
      <main data-id="element-1">
        <HeroSection data-id="element-2" />
        <OpeningHook data-id="element-3" />
        <ProblemSection data-id="element-4" />
        <FailedApproaches data-id="element-5" />
        <MechanismSection data-id="element-6" />
        <WhatYouGet data-id="element-7" />
        <WhoIsThisFor data-id="element-8" />
        <HowItWorks data-id="element-9" />
        <ProofSection data-id="element-10" />
        <FAQSection data-id="element-11" />
        <OfferSection data-id="element-12" />
      </main>
      <FooterSection data-id="element-13" />
    </div>;
}